import {
  addSignalAttribute,
  init,
  reportError as dash0ReportError,
} from '@dash0/sdk-web';

import type { ErrorReporter } from '@xing-com/crate-xinglet';

import type { Dash0InitOptions } from './types';

export function setupDash0({
  serviceName = 'crate-app',
  endpoint,
  serviceVersion,
  environment,
  ...options
}: Partial<Dash0InitOptions> = {}): ErrorReporter {
  const isTestingMachine =
    document.location.hostname === 'ci-docker1.env.xing.com';
  if (
    isTestingMachine ||
    !environment ||
    !serviceName ||
    !endpoint?.url ||
    !endpoint?.authToken
  ) {
    return function ignoreError() {
      //
    };
  }

  init({
    serviceName,
    endpoint,
    environment,
    serviceVersion,
    ...options,
  });

  addSignalAttribute('obs.standardized.cost_center', '20160');
  addSignalAttribute('service.namespace', 'crate');

  return function reportError(error, context) {
    dash0ReportError(error, context);
  };
}
